export default {
	dialogPaper: {
		overflowY: 'hidden',
		maxWidth: 768,
	},
	dialogActionsRoot: {
		width: '100%',
	},
};
